import React, { useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getEmbedUrl } from '@culture/common-helpers/materials';
import { getImageUrl } from '@culture/common-helpers/cultureUtils';

import { ImageFormatContext } from 'contexts/ImageFormatContext';
import Preloader from 'components/Preloader';

import { MaterialPropType } from 'propTypes/common';

import styles from '../styles.module.scss';

const Video = ({ material, alone }) => {
	const [loaded, setLoaded] = useState(false);
	const imageFormat = useContext(ImageFormatContext);

	const onLoad = useCallback(() => {
		setLoaded(true);
	}, []);

	const itemCx = cx(styles.lightboxItem, {
		[styles.alone]: alone
	});
	const iframeCx = cx(styles.video, {
		[styles.loaded]: loaded
	});
	const imageSrc = getImageUrl(material, { format: imageFormat });

	return (
		<div className={itemCx} style={{ backgroundImage: `url(${imageSrc})` }}>
			<iframe
				title={material.title}
				src={getEmbedUrl(material)}
				className={iframeCx}
				allowFullScreen
				onLoad={onLoad}
			/>
			{!loaded && <Preloader className={styles.preloader} />}
		</div>
	);
};

Video.propTypes = {
	material: MaterialPropType.isRequired,
	alone: PropTypes.bool
};

Video.defaultProps = {
	alone: false
};

export default Video;
